import { ReactNode } from 'react';
import { breakpoints } from 'styles';
import { useReduxState } from 'hooks';

interface Props {
  children: ReactNode;
  customContent?: string;
  customContentBeside?: boolean;
  customContentBesideBreakpoint?: 'medium' | 'huge';
}

const PagePlainCustomContent = ({
  children,
  customContent,
  customContentBeside,
  customContentBesideBreakpoint = 'medium'
}: Props) => {
  const { theme } = useReduxState();

  return (
    <div
      className={`content ${
        customContent && customContentBeside ? 'content-with-beside' : ''
      }`}
    >
      {customContent ? (
        <div
          className="custom-content"
          dangerouslySetInnerHTML={{
            __html: customContent
          }}
        />
      ) : null}

      <div className="inner-content">{children}</div>

      <style jsx>{`
        .content {
          display: flex;
          flex-direction: column;
        }
        .custom-content {
          color: ${theme.textColorLight};
          flex-grow: 1;
          font-size: 1.5rem;
          padding: 25px 25px 0;
        }
        .custom-content :global(p) {
          margin: 15px 0 0;
        }
        .custom-content :global(p:first-child) {
          margin-top: 0;
        }
        .inner-content {
          flex-shrink: 0;
          padding: 20px;
        }
        @media (min-width: ${breakpoints[customContentBesideBreakpoint]}px) {
          .content-with-beside {
            flex-direction: row;
          }
          .content-with-beside .custom-content {
            border-right: 1px solid ${theme.lightGrey};
            margin-bottom: 0;
            padding: 25px;
          }
          .content-with-beside .inner-content {
            width: 320px;
          }
          .inner-content {
            padding: 25px;
          }
        }
      `}</style>
    </div>
  );
};

export default PagePlainCustomContent;
